import ReactGA from 'react-ga';

export default class GoogleAnalytics {
  constructor({googleAnalyticsKey}) {
    this.googleAnalyticsKey = googleAnalyticsKey;
    if (googleAnalyticsKey) {
      ReactGA.initialize(googleAnalyticsKey);
    }
  }

  trackPage = ({pathname, search, origin}) => {
    if (!this.googleAnalyticsKey) {
      return;
    }

    const page = `${pathname}${search}`;
    ReactGA.set({
      page,
      location: `${origin}${page}`,
    });
    ReactGA.pageview(page);
  };
}
